import { Button } from 'components/common/button/Button';

interface InvitationData {
    meetingName: string;
    hostName: string;
    date: string;
    time: string;
    location: string;
    participants: number;
    description?: string;
}

interface InvitationEntryContentProps {
    invitation: InvitationData;
    onJoin: () => void;
    onDecline: () => void;
}

export const InvitationEntryContent = ({ invitation, onJoin, onDecline }: InvitationEntryContentProps) => {
    return (
        <>
            {/* Invitation Header */}
            <div className="invitation-header">
                <div className="invitation-icon">✉️</div>
                <h1 className="invitation-title">모임 초대장</h1>
                <p className="invitation-subtitle">
                    {invitation.hostName}님이 모임에 초대했어요
                </p>
            </div>

            {/* Meeting Preview Card */}
            <div className="meeting-preview-card">
                <div className="preview-header">
                    <h2 className="preview-meeting-name">{invitation.meetingName}</h2>
                    <div className="preview-participants">
                        👥 {invitation.participants}명 참여 중
                    </div>
                </div>

                <div className="preview-details">
                    <div className="preview-item">
                        <span className="preview-icon">👤</span>
                        <div className="preview-info">
                            <div className="preview-label">주최자</div>
                            <div className="preview-value">{invitation.hostName}</div>
                        </div>
                    </div>

                    <div className="preview-item">
                        <span className="preview-icon">📅</span>
                        <div className="preview-info">
                            <div className="preview-label">날짜</div>
                            <div className="preview-value">{invitation.date}</div>
                        </div>
                    </div>

                    <div className="preview-item">
                        <span className="preview-icon">⏰</span>
                        <div className="preview-info">
                            <div className="preview-label">시간</div>
                            <div className="preview-value">{invitation.time}</div>
                        </div>
                    </div>

                    <div className="preview-item">
                        <span className="preview-icon">📍</span>
                        <div className="preview-info">
                            <div className="preview-label">장소</div>
                            <div className="preview-value">{invitation.location}</div>
                        </div>
                    </div>
                </div>

                {invitation.description && (
                    <div className="preview-description">
                        <div className="description-label">모임 설명</div>
                        <div className="description-text">{invitation.description}</div>
                    </div>
                )}
            </div>

            {/* Info Message */}
            <div className="info-message">
                <div className="info-icon">ℹ️</div>
                <div className="info-text">
                    참여를 확정하시려면 간단한 정보를 입력해 주세요
                </div>
            </div>

            {/* Action Buttons */}
            <div className="invitation-actions">
                <Button
                    text="참여하기"
                    onPress={onJoin}
                />
                <button className="decline-button" onClick={onDecline}>
                    다음에 할게요
                </button>
            </div>
        </>
    );
};
